import { userIdQuery } from '../../authentication/queries';
import { createCommand } from '../../utils';
import { moduleName, setColumnVisibility } from '../state';

const SaveColumnsPreference = createCommand(
    `${moduleName}/SAVE_COLUMNS_PREFERENCE`,
    async (model: Record<string, boolean>, { dispatch, extra, getState }) => {
        const userId = userIdQuery(getState());
        if (userId) {
            extra.externalNetworkConfiguration.saveColumnVisibility(userId, model);
            dispatch(setColumnVisibility(model));
        }
    },
);

export default SaveColumnsPreference;
